import React from 'react';
import Icon from '../Icon';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contextProviders';

function AddSegmentRow({ onClick, onToggleSegmentationVisibility = null, segmentation = null }) {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation('SegmentationTable');
  return (
    <div className={`flex justify-between ${isDarkMode ? 'bg-white' : 'bg-black'} pl-[34px] hover:cursor-pointer`}>
      <div
        className="group py-[5px] pb-[5px]"
        onClick={onClick}
      >
        <div className={`${isDarkMode ? 'text-black' : 'text-primary-active'} group-hover:${isDarkMode ? 'bg-customLightColor-level3' : 'bg-secondary-dark'} flex items-center rounded-[4px] pr-2`}>
          <div className="grid h-[28px] w-[28px] place-items-center">
            <Icon name="icon-add" />
          </div>
          <span className="text-[13px]">{t('Add segment')}</span>
        </div>
      </div>
      {segmentation && (
        <div className="flex items-center">
          <div
            className="hover:bg-secondary-dark ml-3 mr-1 grid h-[28px]  w-[28px] cursor-pointer place-items-center rounded-[4px]"
            onClick={() => onToggleSegmentationVisibility(segmentation.id)}
          >
            {segmentation.isVisible ? (
              <Icon
                name="row-shown"
                className="text-primary-active"
              />
            ) : (
              <Icon
                name="row-hidden"
                className="text-primary-active"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AddSegmentRow;
